export default ({ store, redirect }) => {
  const currentUser = store.state.auth.currentUser
  const shouldConfirmPhone = currentUser && currentUser.cell_phone && (!currentUser.cell_phone_confirmed || currentUser.cell_phone_to_confirm)
  if (!shouldConfirmPhone) {
    return redirect('/')
  }
}
